/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useSearchParams } from "react-router";
import { useAuth } from '@/commons/auth';
import FormUbahRuangan from '../components/FormUbahRuangan'

import getRuanganData from '../services/getRuanganData'
const UbahRuanganPage = props => {
const { id } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	ubahRuangan: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [ruanganData, setRuanganData] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, ubahRuangan: true}))
		const { data: ruanganDataResponse } = await getRuanganData({ id  })

	    setRuanganData(ruanganDataResponse.data)


	    setIsLoading(prev => ({...prev, ubahRuangan: false}))
    }
	if (checkPermission("UpdateRuangan")) { 
		fetch()
	}
  }, [])

	
	useEffect(() => {
		setTitle("Ubah Ruangan Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/ruangan/${id}
			  	`}>
			  		<Button id="_TBsdYCsNEfCz9KF7E6i0TQ" className="p-4" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("UpdateRuangan") && ( 
	<Layouts.FormContainerLayout
		singularName={"Ruangan"}
		isLoading={isLoading.ubahRuangan}
	>
		{ruanganData ? 
		(<>
		 <FormUbahRuangan
			{...{ 
				ruanganData
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default UbahRuanganPage

